import RangeSlider from './RangeSlider';

export default () => {
  // Configuration overrides
  const configurations = new Map();
  const configTypes = ['price-slider-vertical', 'price-slider-horizontal', 'price-slider-modal'];

  // Loop all config types and set config accordingly
  configTypes.forEach((configType) => {
    const priceSliderEl = document.querySelector(`.js-range-slider[data-config="${configType}"]`);

    if (priceSliderEl) {
      const minPrice = parseInt(priceSliderEl.dataset.minPrice, 10);
      const maxPrice = parseInt(priceSliderEl.dataset.maxPrice, 10);

      // Optionally set different slider options by selecting the slider based on data-config
      configurations.set(configType, {
        range: {
          min: [minPrice],
          max: [maxPrice + 10],
        },
        step: 10,
        start: [minPrice, maxPrice + 10],
        connect: true,
        direction: 'ltr',
        orientation: 'horizontal',
        behaviour: 'tap',
        tooltips: false,
      });
    }
  });

  const rangeSliders = document.querySelectorAll('.js-range-slider');
  [...rangeSliders].forEach((rangeSliderEl) => {
    // Check if slider already exists
    if (rangeSliderEl.noUiSlider) {
      return;
    }

    const configName = rangeSliderEl.dataset.config;
    let config = configurations.get(configName);

    if (!config) {
      config = rangeSliderEl;
    }

    window.rangeSliders = {
      ...window.rangeSliders,
      [configName]: new RangeSlider(rangeSliderEl, config),
    };

    const minInput = document.querySelector(`.js-min-value[data-config="${configName}"]`);
    const maxInput = document.querySelector(`.js-max-value[data-config="${configName}"]`);
    const valueRangeMin = document.querySelector(
      `.js-range-placeholder-min[data-config="${configName}"]`,
    );
    const valueRangeMax = document.querySelector(
      `.js-range-placeholder-max[data-config="${configName}"]`,
    );

    if (minInput && maxInput) {
      // Update values
      window.rangeSliders[configName].slider.on('update', (values) => {
        const min = values[0];
        const max = values[1];

        valueRangeMin.innerHTML = `€ ${Math.round(min)}`;
        valueRangeMax.innerHTML = `€ ${Math.round(max)}`;
      });

      // Update inputs once change is complete
      window.rangeSliders[configName].slider.on('change', (values) => {
        const min = values[0];
        const max = values[1];

        minInput.value = Math.round(min);
        maxInput.value = Math.round(max);

        const event = new Event('input', {
          bubbles: true,
        });

        minInput.dispatchEvent(event);
        maxInput.dispatchEvent(event);
      });

      // if value of input is changed update handle of slider
      minInput.addEventListener('input', () => {
        window.rangeSliders[configName].slider.target.noUiSlider.set(
          [minInput.value, maxInput.value],
          true,
          true,
        );
      });

      maxInput.addEventListener('input', () => {
        window.rangeSliders[configName].slider.target.noUiSlider.set(
          [minInput.value, maxInput.value],
          true,
          true,
        );
      });
    }
  });
};
